<template>
    <AddCreance />
  </template>
  
  <script lang="ts">
    import { defineComponent } from "vue";
  
    
    import AddCreance from "@/components/GesCom/Creance/AddCreance.vue";
  
    export default defineComponent({
      name: "AddCreancePage",
      components: {
        
        AddCreance,
      },
    });
  </script>